// extracted by mini-css-extract-plugin
module.exports = {"chartTitleWrap":"style_chartTitleWrap__2zEtU","line":"style_line__3X5fZ","title":"style_title__12yGt","subTitle":"style_subTitle__3mL5b"};